module.exports = "/_next/static/images/4255d883ba39542372de2789c02dfbe2-check-circle.svg";